var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doughnut-chart-container"},[_c('canvas',{attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }